/** The card's colours; the plot's own colours stay in layout/plot-geometry.ts. */
export const INK = "#404040";
export const TEXT_SECONDARY = "#5f5e5a";
export const TEXT_TERTIARY = "#74726c";
export const TEXT_STALE = "#6b6a65";
/** Hairlines: the card border, the header rule and the divider. */
export const RULE_COLOR = "#e4e3df";
export const CARD_BACKGROUND = "#fafaf9";
export const CONTROL_BORDER = "#dcdbd6";
/** Text on an ink pill. */
export const TEXT_ON_INK = "#ffffff";
export const TEXT_ON_INK_MUTED = "rgba(255, 255, 255, 0.8)";
export const LIVE_DOT = "var(--primary)";
export const STALE_DOT = "#b5b3ac";
export const STALE_PILL_BG = "#f1f0ec";
/** The legend row a panel has focused. */
export const FOCUSED_ROW_BACKGROUND = "#ecebe7";
/** Swatches on the other legend rows while one is focused. */
export const DIMMED_SWATCH_OPACITY = 0.45;
